/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Field_Name_HintInputs */

const vi_grower_area_camera_field_name_hint = /** @type {(inputs: Grower_Area_Camera_Field_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên người dùng thấy trên thẻ, ví dụ "Camera cổng vào".`)
};

/**

* @param {Grower_Area_Camera_Field_Name_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_field_name_hint = /** @type {((inputs?: Grower_Area_Camera_Field_Name_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Field_Name_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_field_name_hint(inputs)
});